import P2GContentDropDown from '../../P2GContentDropDown';
import { P2GLink } from '@parcel2go/core-ui';
import DropItem from '../item/DropItem';
import { EditType } from '../item/EditType';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { P2GGrid } from '@parcel2go/core-ui';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';
import useGoto from '~/hooks/use-goto';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { useEventEmitter } from '~/apps/smartsend/lib/em/Hooks';
import { EditEventType } from '~/apps/smartsend/lib/em/EmitTypes';
import { useCallback } from 'react';

interface props {
  onOpen?: () => void;
  children: React.ReactNode;
}

export const Add: React.FC<props> = (props) => {
  const { goTo } = useGoto();
  const { emit } = useEventEmitter<EditEventType>();
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  const setAction = useCallback(
    (a: EditType) => {
      switch (a) {
        case 'CSV':
        case 'RESTORE':
        case 'CREATE':
          goTo(RoutingConstants.SmartSend);
          break;
      }
      emit('openEdit', { Id: null, Action: a });
    },
    [emit, goTo]
  );

  return (
    <P2GContentDropDown control={props.children} onOpen={props.onOpen}>
      <P2GGrid container spacing={2} justify={'flex-start'} direction={'column'}>
        {SettingsCache.settings.Features.includes('CsvUpload') && (
          <DropItem>
            <P2GLink onClick={() => setAction('CSV')}>
              {t('ADD_TOOLTIP_UPLOAD_CSV', { defaultValue: 'Upload CSV' })}
            </P2GLink>
          </DropItem>
        )}
        <DropItem>
          <P2GLink onClick={() => setAction('CREATE')}>
            {t('ADD_TOOLTIP_ADD_MANUAL_ITEM', { defaultValue: 'Add Manual Order' })}
          </P2GLink>
        </DropItem>
        <DropItem>
          <P2GLink onClick={() => goTo(RoutingConstants.AccountLinking)}>
            {t('ADD_TOOLTIP_LINK_ACCOUNT', { defaultValue: 'Link Account' })}
          </P2GLink>
        </DropItem>
        {SettingsCache.settings.Features.includes('RestoreItem') && (
          <DropItem>
            <P2GLink onClick={() => setAction('RESTORE')}>
              {t('ADD_TOOLTIP_RESTORE_ITEM', { defaultValue: 'Restore Deleted' })}
            </P2GLink>
          </DropItem>
        )}
      </P2GGrid>
    </P2GContentDropDown>
  );
};

export default Add;
